import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

// 全局数据管理
import errorLog from './modules/common/errorLog'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    errorLog
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/data/store/index.js